import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import moment from 'moment'

import "../src/design/app.scss";

import store from '@/state/store'

import App from './App.vue'

import { initFirebaseBackend } from './authUtils'
import i18n from './i18n'

import { configureFakeBackend } from './helpers/fake-backend';

import tinymce from 'vue-tinymce-editor'

import axios from "axios";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}
  const apiClient = axios.create({
    // baseURL: 'https://services.dev.medicinohealthtech.in/'
    // baseURL: 'http://127.0.0.1:8000/',
    // baseURL: 'https://staging.medicino.in/',  
    baseURL: 'https://api.brightideainfotech.tech/',


  });

  // Add a response interceptor
  apiClient.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        // Redirect to login page
        router.push({ name: 'login' });
      }else if (error.response && error.response.status === 503) {
        // Show a maintenance message or redirect to a maintenance page
      
        const reason = error.response.data.error 
        ? error.response.data.error 
        : 'The application is under maintenance. Please try again later.';
        Vue.prototype.$maintenanceMessage = reason;
        alert(Vue.prototype.$maintenanceMessage); // Show an alert (or use a toast library)
        
        // Optionally, redirect to a maintenance page
        router.push('/maintenance').catch(() => {}); // Ensure it doesn't throw an error if already on the page
      }
      return Promise.reject(error);
    }
  );

Vue.prototype.$axios = apiClient;
// Vue.prototype.$image_url = 'http://127.0.0.1:8000/storage/app/public/';
// Vue.prototype.$image_url = 'http://127.0.0.1:8000/storage/app/public/';
// Vue.prototype.$image_url = 'https://staging.medicino.in/storage/';
Vue.prototype.$image_url = 'https://api.brightideainfotech.tech/storage/';




Vue.filter("formatDateTime", function (datetime) {
  if (datetime) {
    //alert(datetime);
    return moment.utc(datetime).format("DD MMM YYYY, hh:mm A");
  }
});

Vue.filter("formatDate", function (date) {
  if (date) {
    return moment(date).format("DD MMM YYYY");
  }
});

Vue.filter("formatTimeOnly", function (datetime) {
  if (datetime) {
    return moment(datetime).format("hh:mm A");
  }
});

Vue.filter('formatTime', function(time) {
  if(time) {
    var datetime = '2022-02-08 ' + time;
    return moment.utc(datetime).format('hh:mm A');
  }
});

Vue.component('tinymce', tinymce)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
//Vue.use(VueSweetalert2);
Vue.use(VueSweetalert2, {
  position: "top-end",
  showConfirmButton: false,
  timer: 2000,
  toast: true,
});
Vue.use(VueGoogleMaps, {
  load: {
    // key: 'AIzaSyDmehs_u8H6kgD9d9aVV38RuAS-GSZT598',

    // key: 'AIzaSyBCN42iAP4i3_QUcP9HRALRmCuZtA1iLEM', // Medicino Key
    key: 'AIzaSyBfNQlPkpdeMTVg6VKLvEF3OF8WgDM_wUY',

    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
